var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedInFSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social icon",
    clipPath: "url(#clip0_5720_106713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.2234 0.95166H1.77187C0.792187 0.95166 0 1.7251 0 2.68135V23.2173C0 24.1735 0.792187 24.9517 1.77187 24.9517H22.2234C23.2031 24.9517 24 24.1735 24 23.222V2.68135C24 1.7251 23.2031 0.95166 22.2234 0.95166ZM7.12031 21.4032H3.55781V9.94697H7.12031V21.4032ZM5.33906 8.38604C4.19531 8.38604 3.27188 7.4626 3.27188 6.32353C3.27188 5.18447 4.19531 4.26103 5.33906 4.26103C6.47813 4.26103 7.40156 5.18447 7.40156 6.32353C7.40156 7.45791 6.47813 8.38604 5.33906 8.38604ZM20.4516 21.4032H16.8937V15.8345C16.8937 14.5079 16.8703 12.797 15.0422 12.797C13.1906 12.797 12.9094 14.2454 12.9094 15.7407V21.4032H9.35625V9.94697H12.7687V11.5126H12.8156C13.2891 10.6126 14.4516 9.66104 16.1813 9.66104C19.7859 9.66104 20.4516 12.0329 20.4516 15.1173V21.4032Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5720_106713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.95166)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInFSvg);
export default __webpack_public_path__ + "static/media/LinkedInFSvg.83c7fa8f2e91675be110d4920c4f31b9.svg";
export { ForwardRef as ReactComponent };